import { ADD_ALERT, REMOVE_ALERT } from "./actionTypes";

export const addAlert = message => dispatch => {
    dispatch({ type: ADD_ALERT, payload: message });
};

export const removeAlert = () => dispatch => {
    dispatch({ type: REMOVE_ALERT });
};
